import {LitElement, html, css} from 'lit';

/**
 * Comment Element
 */
export class Comment extends LitElement {
  static get styles() {
    return css`
      .comment { 
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
        box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);
        color: var(--body-color,#B9B5AF);
      }

      .comment_avatar {
          width: 80px;
          max-width: 80px;
          max-height: 80px;
      }

      .comment__body {
        display: flex;
        flex-direction: row;
        background-color: var(--panel-bg-color,#141414);
        border-top-left-radius: var(--border-radius-base,6px);
        border-top-right-radius: var(--border-radius-base,6px);
      }

      .comment__content {
        width: 100%;
        padding: 16px;
      }

      .comment__meta {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: var(--panel-heading-bg-color,#272727);
        padding: 0.5rem;
        font-size: 1rem;
      }

      .comment__meta:first-child {
        border-top-left-radius: var(--border-radius-base,6px);
        border-top-right-radius: var(--border-radius-base,6px);
      }

      .comment__meta:last-child {
        border-bottom-left-radius: var(--border-radius-base,6px);
        border-bottom-right-radius: var(--border-radius-base,6px);
      }

      .comment__meta-right {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .comment__meta-left {
        display: flex;
        flex-direction: row;
        align-items: center;
      }


      .icon {
        width: 16px;
        height: 16px;
      }

      a, a:hover, a:visited {
          color: var(--link-color,#A89368);
          text-decoration: none;
      }

      .comment__nested {
        margin-left: 2rem;
      }
      .username--admin {
        color: #9b0000;
        font-weight: bold;
      }
      nft-element {
        margin-left: 1em;
      }
    `;
  }

  static get properties() {
    return {
      id: {type: Number},
      parent_id: {type: Number},
      comment: {type: String},
      submit_date: {type: String},

      level: {type: Number},
      user_id: {type: Number},
      user_name: {type: String},
      user_name_profile: {type: String},
      user_avatar: {type: String},
      staff: {type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }
      },
      patron: {type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }
      },
      verified: {type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }
      },

      canDelete: {type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }},
      canReply: {type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }},
      canFlag: {type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }},
      pageCommentsDisabled: {
        type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }
      },
      flagCount: {type: Number},
      likeCount: {type: Number},
      dislikeCount: {type: Number},
      nftblock: {type: Boolean,
        hasChanged(newVal, oldVal) {
          return newVal !== oldVal;
        },
        converter: {
          fromAttribute: (value, type) => {
            if (value === 'true' || value === 'True' || value == '1' || value === true) {
              return true;
            }
            if (value === 'false' || value === 'False' || value == '0' || value === false ) {
              return false;
            }
            return false;
          }
        }
      },
    };
  }

  constructor() {
    super();
    this.id = 0;
    this.parent_id = 0;
    this.user_id = 0;
    this.user_name = 'User';
    this.user_name_profile = '';
    this.user_avatar = 'https://s3.eu-central-1.wasabisys.com/open3dlab-static/img/mike.jpg';
    this.staff = false;
    this.patron = false;
    this.verified = false;
    this.comment = 'Message';
    this.submit_date = 'date';
    this.canDelete = false;
    this.canReply = false;
    this.canFlag = true;
    this.pageCommentsDisabled = false;
    this.flagCount = 0;
    this.likeCount = 0;
    this.dislikeCount = 0;
    this.nftblock = false;
  }

  getUsernameTemplate() {
    return html`<username-element username="${this.user_name}" profilename="${this.user_name_profile}" staff="${this.staff}" patron="${this.patron}" verified="${this.verified}">${this.user_name}</username-element> `;
  }

  getDeleteButtonTemplate() {
    if (this.canDelete) {
      return html`<comment-action-element comment_id="${this.id}" actionType="delete"></comment-action-element>`;
    }
    
    return html``;
  }

  getReplyButtonTemplate() {
    if (this.canReply && this.pageCommentsDisabled == false) {
      return html`<comment-action-element comment_id="${this.id}" actionType="reply"></comment-action-element>`;
    }

    return html``;
  }

  getFlagButtonTemplate() {
    if (this.canFlag) {
      return html`<comment-action-element comment_id="${this.id}" actionType="flag" actionCount="${this.flagCount}"></comment-action-element>`;
    }

    return html``;
  }

  getLikeButtonTemplate() {
    return html`<comment-action-element comment_id="${this.id}" actionType="like" actionCount="${this.likeCount}"></comment-action-element>`;
  }

  getDislikeButtonTemplate() {
    return html`<comment-action-element comment_id="${this.id}" actionType="dislike" actionCount="${this.dislikeCount}"></comment-action-element>`;
  }

  getNftBlock() {
    if (this.nftblock) {
      return html`<nft-element title="Mint Comment as NFT"></nft-element>`;
    }
  }

  render() {
    return html`
        <div class="comment">

          <div class="comment__meta">
            <div class="comment__meta-left">
              <a href="/user/${this.user_id}/">${this.getUsernameTemplate()}</a> posted on ${this.submit_date} 
            </div>
            <div class="comment__meta-right">
              ${this.getFlagButtonTemplate()}
              ${this.getDeleteButtonTemplate()}
            </div>
          </div>

          <div class="comment__body">
            <img alt="${this.user_name}" class="comment_avatar" src="${this.user_avatar}" loading="lazy">
            <div class="comment__content">
              <div class="content">${this.comment}</div>
            </div>
          </div>

          <div class="comment__meta">
            <div class="comment__meta-left">
              ${this.getLikeButtonTemplate()}
              <span class="text-muted">|</span>
              ${this.getDislikeButtonTemplate()}
              ${this.getNftBlock()}
            </div>
            <div class="comment__meta-right">
              ${this.getReplyButtonTemplate()}
            </div>
          </div>

        </div>
        <div class="comment__nested">
        <slot></slot>
        </div>
    `;
  }
}

window.customElements.define('comment-element', Comment);

/**
 * Settings
 */
let pageCommentList = [];
let orphanCommentList = [];
let pageCommentContainer = null;
let pageNFTBlockEnabled = false;
let pageCommentSortingElement = null;
let pagecommentSortingMode = '-submit_date';
let pageCommentsDisabled = false;
let pageCommentOffset = 0;
let pageCommentLimit = 20;
let pageCommentTotal = 0;
let pageCommentAllButtonThreshold = 4;
let commentCountElements = null;
/**
 * Intersection observer to animate and make the comments viewable
 */
let interSectionObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if(entry.isIntersecting === true){
      entry.target.classList.add("comment-element--open")
      interSectionObserver.unobserve(entry.target);
    }
  });
}, { threshold: [0] });

/**
 * Load comment data using limit and offset
 * 
 * @param {*} pk 
 * @param {*} callback 
 */
function fetchCommentData(pk, callback, getAllComments = false) {
  var commentURL = '';
  if (getAllComments) {
      commentURL = '/comments/api/projectrepo-project/' + pk + '/?format=json&limit=' + pageCommentTotal + '&offset=' + pageCommentOffset + '&order_by=' + pagecommentSortingMode;
  } else {
      commentURL = '/comments/api/projectrepo-project/' + pk + '/?format=json&limit=' + pageCommentLimit + '&offset=' + pageCommentOffset + '&order_by=' + pagecommentSortingMode;
  }

  var myInit = {
      method: 'GET'
  };

  var myRequest = new Request(commentURL, myInit);

  fetch(myRequest).then(function(response) {
      callback(response);
  }).catch(function(e){
      console.log(e);
  });
}

function checkOrphanedComments() {
  orphanCommentList.forEach(function(comment) {
      if (pageCommentList[comment.parent_id]) {
        pageCommentList[comment.parent_id].appendChild(comment);
      }
  });
}

/**
 * Append comment data to the page
 * @param {*} jsonResponseData 
 */
function processCommentData(jsonResponseData) {
  var commentData = jsonResponseData.results;
  pageCommentTotal = jsonResponseData.count;
  updateCommentCounts(commentCountElements);

  let loadAllButtonElement = document.getElementById('load-all-comments');
  // If we only loaded a partial set of comments, we show the load more button
  let loadMoreButtonElement = document.getElementById('load-more-comments');
  if (jsonResponseData.next) {
    loadMoreButtonElement.style.display = 'block';  
    if ((pageCommentTotal / pageCommentLimit) > pageCommentAllButtonThreshold) {
      loadAllButtonElement.style.display = 'block';
    }
  } else {
    loadMoreButtonElement.style.display = 'none';
    loadAllButtonElement.style.display = 'none';
  }

  // Loop over received comment and append to page
  commentData.forEach(function(comment) {
    var commentElement = undefined;
    // Comment placeholders
    if (comment.is_shadowbanned || comment.is_removed) {
      commentElement = document.createElement('p');
      var usernameElement = '<username-element username="' + comment.user_name + '" profilename="' + comment.user_name_profile + '" staff="' + comment.user_is_staff + '" patron="' + comment.user_is_patron + '" verified="' + comment.user_is_verified + '">${this.user_name}</username-element>';
      if (comment.is_shadowbanned) {
        commentElement.innerHTML = '<i class="fa fa-eye-slash" aria-hidden="true"></i> Comment by shadowbanned user <a href="/user/' + comment.user_id + '/">' + usernameElement + '</a>.';
      }
      if (comment.is_removed && !comment.is_shadowbanned) {
        commentElement.innerHTML = '<i class="fa fa-trash" aria-hidden="true"></i> Removed comment from <a href="/user/' + comment.user_id + '/">' + usernameElement + '</a>.';
      }
      commentElement.classList.add('comment-element');
    } else {
      // Comment element
      commentElement = document.createElement('comment-element');

      commentElement.id = comment.id;
      commentElement.parent_id = comment.parent_id;
      commentElement.comment = comment.comment;
      commentElement.submit_date = comment.submit_date;
      commentElement.level = comment.level;
      commentElement.user_id = comment.user_id;
      commentElement.user_name = comment.user_name;
      commentElement.user_name_profile = comment.user_name_profile;
      commentElement.user_avatar = comment.user_avatar;
      commentElement.canDelete = comment.can_delete;
      commentElement.canReply = comment.allow_reply;
      commentElement.patron = comment.user_is_patron;
      commentElement.verified = comment.user_is_verified;
      commentElement.staff = comment.user_is_staff;
      let flagCount = 0;
      let likeCount = 0;
      let dislikeCount = 0;
      comment.flags.forEach(function(flag) {
        // Removal Flag
        if (flag.flag == 'removal') {
          flagCount += 1;
        }
        // Like Flag
        if (flag.flag == 'like') {
          likeCount += 1;
        }
        // Dislike Flag
        if (flag.flag == 'dislike') {
          dislikeCount += 1;
        }
      });
      commentElement.flagCount = flagCount;
      commentElement.likeCount = likeCount;
      commentElement.dislikeCount = dislikeCount;
      commentElement.pageCommentsDisabled = pageCommentsDisabled;
      commentElement.nftblock = pageNFTBlockEnabled;
    }

    pageCommentList[comment.id] = commentElement;

    if(comment.level !== 0) {
      if (pageCommentList[comment.parent_id]) {
        pageCommentList[comment.parent_id].appendChild(commentElement);
        // A new element has been added. check for orphaned children
      } else {
        orphanCommentList[comment.id] = commentElement;
      }
    } else {
      pageCommentContainer.appendChild(commentElement);

      // A new parent element has been added. check for orphaned children
      if (pageCommentList[comment.id]) {
        for (var child in orphanCommentList) {
          if (child.parent_id == comment.id) {
            pageCommentList[comment.id].appendChild(child);
          }
        }
      }
    }

    pageCommentOffset += 1;
    
    // Start observing when the comment becomes visible
    interSectionObserver.observe(commentElement);
  });

  checkOrphanedComments();

  if (pageCommentList.length == 0) {
    if (orphanCommentList.length == 0) {
      pageCommentContainer.innerHTML = '<p>No comments yet.</p>';
    } else {
      console.log('Orphaned comments: ' + orphanCommentList.length);
      console.log('Fetching until we have parent level comments.');
      startFetchingComments();
    }
  }
}

/**
 * Load comments when the page is ready
 */
document.addEventListener("DOMContentLoaded", function(event) {
  pageCommentContainer = document.getElementById('comment-container-new');
  if (pageCommentContainer) {
    pageCommentsDisabled = pageCommentContainer.dataset.commentsDisabled == 'True';
    pageNFTBlockEnabled = pageCommentContainer.dataset.nftblock == 'True';
    if (pageCommentContainer) {
      startFetchingComments();
    
      commentCountElements = document.getElementsByClassName('comment-count');
      if (commentCountElements.length > 0) {
        updateCommentCounts(commentCountElements);
      }

      let loadMoreButtonElement = document.getElementById('load-more-comments');
      let loadAllButtonElement = document.getElementById('load-all-comments');
      if (loadMoreButtonElement) {
        loadMoreButtonElement.addEventListener('click', function() {
          let projectId = pageCommentContainer.dataset.projectId;
        
          startFetchingComments();
        });
      }
      if (loadAllButtonElement) {
        loadAllButtonElement.addEventListener('click', function() {
          let projectId = pageCommentContainer.dataset.projectId;
        
          startFetchingComments(true);
        });
      }

      pageCommentSortingElement = document.getElementById('comment-sorting');
      if (pageCommentSortingElement) {
        pageCommentSortingElement.addEventListener('change', function() {
          pagecommentSortingMode = pageCommentSortingElement.value;

          pageCommentOffset = 0;
          pageCommentList = {};
          orphanCommentList = {};
          pageCommentContainer.innerHTML = '';
          
          startFetchingComments();
        });
      }
    }
  }
});

function startFetchingComments(allComments = false) {
  let projectId = pageCommentContainer.dataset.projectId;
  fetchCommentData(projectId, function appendComments(response) {
    response.json().then(function (jsonResponseData) {
      processCommentData(jsonResponseData);
    });
  }, allComments);
  return projectId;
}

function updateCommentCounts(commentCountElements) {
  for (let i = 0; i < commentCountElements.length; i++) {
    commentCountElements[i].innerHTML = pageCommentTotal;
  }
}
